$.fn.forceAlphabeticOnly =
function()
{
    return this.each(function()
    {
        $(this).keydown(function(e)
        {
            var key = e.charCode || e.keyCode || 0,
				allowed = false;

            allowed = (
                key == 8 || // backspace
                key == 13 || // enter
                key == 46 || // delete
                key == 37 || // arrow left
                key == 39 || // arrow right
                (key >= 65 && key <= 90) // a-z
			);

			if (e.key) {
				let regex = new RegExp('ă|î|â|ș|ț', 'i');
				allowed = allowed || regex.test(e.key);
			}
			else {
				allowed = allowed || (
					key == 219 || // ă
					key == 221 || // î
					key == 220 || // â
					key == 186 || // ș
					key == 222  // ț
				);
			}

			return allowed;
        });
    });
};


$(document).ready(function() {

	var is_mobile = ($(window).width() < 768),
		bp_max_letter_width = is_mobile ? 100 : 178,
		input = $('#input-sand'),
		sand_draw_wrap = $('.sand-draw-wrap'),
		sand_draw = $('.sand-draw'),
		msg_swear = $('.msg-swear'),
		btn_sand_action = $('.btn-sand-action'),
		btn_sand_action_download = $('#btn-sand-action-download'),
		char_map = {
			ă : 'a1',
			â : 'a2',
			î : 'i1',
			ș : 's1',
			ş : 's1',
			ț : 't1',
			ţ : 't1',
		};

	function draw_on_sand(e, letters) {
		var 
			word,
			word_clean,
			word_arr,
			sand_width = sand_draw_wrap.width(),
			anim_duration = 800;

		e && e.preventDefault();
		sand_draw.html('');
		btn_sand_action.removeClass('onscreen');
		msg_swear.addClass('hidden');

		if (letters) {
			// use supplied letters
			word_arr = letters
				.split(',')
				.filter(char => char.match(/[a-z]|a1|a2|i1|s1|t1/));
		}
		else {
			// use letters from input
			word = input.val().toLowerCase();

			if (is_bad_word(word)) {
				word_clean = 'mamma_mia';
				input.val('');
			}
			else {
				word_clean = word;
			}

			word_arr = word_clean.split('')
				.filter(char => char.match(/[a-z]|ă|î|â|ș|ț|_/))
				.map(char => {
					return (char_map.hasOwnProperty(char)) ? char_map[char] : char;
				});
			// download photo href for new input
			if (btn_sand_action_download.length) {
				let href = btn_sand_action_download.attr('href');
				href = href.replace(/letters\=.*$/, 'letters=' + word_arr.join(','));
				btn_sand_action_download.attr('href', href);
			}
		}

		$('#letters').val(word_arr.join(','));

		for (var i = 0; i < word_arr.length; i++) {
			let hash = new Date().getTime() + Math.random(),
				letter,
				letter_name = word_arr[i],
				letter_width,
				calc_max_letter_width = (sand_width / word_arr.length);
			letter = $('<span><img class="img-fluid" src="assets/images/litere/' + letter_name + '.gif?' + hash + '"></span>');
			letter.appendTo(sand_draw);

			letter_width = (calc_max_letter_width < bp_max_letter_width) ? calc_max_letter_width : bp_max_letter_width;
			letter.width(Math.floor(letter_width));

			(function(letter) {
				setTimeout(() => {
					letter.find('img').css('display', 'inline');
				}, anim_duration * i);
			})(letter);

			setTimeout(() => {
				if (is_bad_word(word)) {
					msg_swear.removeClass('hidden');
				}
				else {
					btn_sand_action.addClass('onscreen');
				}
			}, anim_duration * (word_arr.length-1) + 300);

		}
	}

	if (is_success) {
		$.magnificPopup.open({
			items: {
				src: $('#success-popup'),
			},
			type: 'inline',
			midClick: true,
			showCloseBtn: false,
			fixedContentPos: !is_mobile,
			alignTop: is_mobile,
		});
		draw_on_sand(false, window.name_letters);
	}

	input
		.forceAlphabeticOnly()
		.keyup((e) => {
            if (e.which == 13) draw_on_sand(e);
		});

	$('.js-btn-draw').click((e) => { 
		ga('send', 'event', 'Deseneaza', 'click', 'K_Riviera');
		draw_on_sand(e);
	});

	$('.js-scroll-to').click((e) => {
		var elem = $(e.currentTarget),
			y = is_mobile ? 20 : 100
			target = $(elem.attr('href'));
		e.preventDefault();
		if (target.length) {
			$('body, html').animate({
				scrollTop: target.offset().top - y
			}, 500);
		}
	});

	if (is_mobile) {
		$('.steps').slick({
            infinite: false,
            arrows: true,
            dots: false,
            speed: 200,
            slidesToShow: 1,
            slidesToScroll: 1,
			adaptiveHeight: true,
        });
	}
    
    $('.js-btn-participa').click((e) => {
		e.preventDefault();
		$(window).scrollTop(0);
	});

	$('.open-form-popup').magnificPopup({
        type: 'inline',
        midClick: true,
        showCloseBtn: false,
		fixedContentPos: !is_mobile,
		alignTop: is_mobile,
    });

	$('.js-close-modal').click((e) => {
		e.preventDefault();
		$.magnificPopup.close();
	});

});

function unique_email(value) {
    $.ajax({
        data: 'validate_email=' + value,
        url: base_url,
        type: 'post',
        async: false,
        dataType: 'text',
        global: false,
        beforeSend: function() {
            valid = null;
        },
        success: function(data, textStatus) {
            if (data === 'valid') {
                valid = true;
            }
            else {
                valid = false;
            }
        }
    });

    if (valid === true) {
        return true;
    }

    return false;
}

function is_bad_word(word) {
	var bad_words = [
		'pula',
		'puli',
		'pulii',
		'pulilor',
		'pizda',
		'pizdei',
		'pizdelor',
		'pizdele',
		'pizdoc',
		'muie',
		'muist',
		'muista',
		'muisti',
		'muiste',
		'muistele',
		'coaie',
		'cur',
		'cururi',
		'curului',
		'fund',
		'suge',
		'suge-o',
		'sugea-mi-ai',
		'sugeami-ai',
		'sugeamiai',
		'fuck',
		'shit',
		'handicapat',
		'cretin',
		'coi',
		'prostilor',
		'handicapati',
		'caca',
		'cacau',
		'cacatul',
		'caca-te',
		'cacate',
		'cacatule',
		'cacatilor',
		'caca-te-as',
		'pish',
		'pishat',
		'pisha-te',
		'pisat',
		'pisatul',
		'pisati',
		'pisatii',
		'pisatule',
		'pisa-te',
		'pis',
		'morti',
		'mortii',
		'ma-ta',
		'mata',
		'baga-mi-as',
		'bagami-as',
		'bagamias',
		'ma-tii',
		'sex',
		'fut',
		'futu-va',
		'fututi',
		'futu-ti',
		'fute-i',
		'fute-te',
		'futai',
		'futut',
		'fututa',
		'sloboz',
		'slobozului',
		'sloboziti',
		'slobozitilor',
		'bulangiu',
		'bulangioaica',
		'bulangii',
		'cordit',
		'cordita',
		'cordite',
		'tarfa',
		'tarfe',
		'poponar',
		'poponari',
		'poponarilor',
		'dracu',
		'dracului',
		'draq',
		'dreq',
		'curva',
		'curvei',
		'curve',
		'curvelor',
		'retardatilor',
		'cacalau',
		'kakalau',
		'buci',
		'gaoaza',
		'goaze',
		'gaoz',
		'gaozului',
		'floci',
		'floc',
		'basina',
		'basini',
		'besi',
		'basesc',
		'basesti',
		'bashina',
		'bashine',
		'beshi',
		'bashesc',
		'bashesti',
		'labagiu',
		'labagii',
	];
	return bad_words.indexOf(word) !== -1;
}
